import type { State } from '../../types';
import { assetsNotDeleted } from './assets-not-deleted';
import { disbledAssetOption } from './disbled-asset-option';
import { sortBy } from 'lodash';
import type { EventRelatedAsset } from '../../../content/event-occurrences/event-related-asset';

export function getAssetOptions(state: State, relatedAssets: EventRelatedAsset[]) {
  const notDiscarded = assetsNotDeleted(state)
    .filter((a) => {
      return (a.isConfirmedEntity && !a.discardedYear) || a.discardedYear === '';
    })
    .map((a) => {
      return {
        value: a.uuid,
        text: a.name + ' ' + a.number,
        disabled: disbledAssetOption(relatedAssets, a),
        discarded: false,
      };
    });
  const discarded = assetsNotDeleted(state)
    .filter((a) => {
      return a.isConfirmedEntity && a.discardedYear && a.discardedYear !== '';
    })
    .map((a) => {
      return {
        value: a.uuid,
        text: a.name + ' ' + a.number + ' (kassert ' + a.discardedYear + ')',
        disabled: disbledAssetOption(relatedAssets, a),
        discarded: true,
      };
    });
  return sortBy(notDiscarded, ['text']).concat(sortBy(discarded, ['text']));
}
